const ActivityTypeLabelsTeacher = {
  song: 'Song',
  video: 'Video',
  craft: 'Craft',
  pictureDictionary: 'Picture dictionary',
  interactiveVideo: 'Video with questions',
  game: {
    classic: 'Memory, Match, Race',
    bubbles: 'Bubbles',
    quiz: 'Quiz',
    imagesQuiz: 'Quiz',
    skate: 'Skateboard',
    sortImages: 'Listen, Think, Match',
  },
  worksheet: 'Worksheet',
  shortStory: 'Short story',
  external: 'Instructions',
  realTime: {
    sortImages: 'Live task',
  },
  comic: 'Comic',
  storyWithQuestions: {
    [undefined]: 'Story with questions',
    story: 'Story',
    quiz: 'Story with questions',
  },
};

export default function typeLabel(type, subType) {
  return (
    ActivityTypeLabelsTeacher[type]?.[subType] ??
    ActivityTypeLabelsTeacher[type]
  );
}

export function getLabelForList({ activity, activities }) {
  const activtiesOfSameType = activities.filter((a) => a.type == activity.type);

  const subTypesCount = getSubTypesCount(activtiesOfSameType);
  const subTypeCount = subTypesCount[activity.data?.subType] || 0;

  const showActivityName =
    activtiesOfSameType.length > 1 &&
    (activity.type != 'game' || subTypeCount > 1);

  let label = showActivityName
    ? activity.name
    : typeLabel(activity.type, activity.data?.subType);

  if (typeof label == 'object') {
    label = '';
  }

  return label;
}

function getSubTypesCount(activities) {
  const subTypesCount = activities.reduce((acc, activity) => {
    if (activity.type == 'game' && activity.data?.subType) {
      if (!acc[activity.data.subType]) {
        acc[activity.data.subType] = 0;
      }
      acc[activity.data.subType]++;
    }
    return acc;
  }, {});

  return subTypesCount;
}
